import React from 'react';
import {
    Typography,
    SvgIcon,
} from '@material-ui/core';

export interface EmptyProps {
    text: string;
}

export default function Empty(props: EmptyProps) {
    const {text} = props;
    
    return (
        <div className="empty">
            <SvgIcon>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 32 32"
                >
                    <path d="M25,4V19l-9,9L7,19V4Z" />
                </svg>
            </SvgIcon>
            <Typography
                variant="body1"
                color="textSecondary"
            >{text}
            </Typography>
        </div>
    );
}
